/* Utils */
import { PageType } from './constants';

export const PLAY_SOURCE_PAGE = {
  [PageType.HOME]: 'HomeLander',
  [PageType.LIVE]: 'LiveLander',
  [PageType.VOD]: 'OnDemandLander',
  [PageType.SPORTS]: 'SportsLander',
  [PageType.KIDS]: 'KidsLander',
  [PageType.SEARCH]: 'Search',
  PDP: 'PDP',
  PLAYER: 'Player',
  SUB_LANDER: 'SubLander',
  INTERSTITIAL: 'Interstistial',
};

export const PLAY_SOURCE_SECTION = {
  FEATURED_CAROUSEL: 'FeaturedCarousel',
  LIVE_CAROUSEL: 'LIVECarousel',
  RESUME_WATCHING_CAROUSEL: 'ResumeWatchingCarousel',
  RECENTLY_WATCHED_CAROUSEL: 'RecentlyWatchedCarousel',
  LIVE_NOW_CAROUSEL: 'LiveNowCarousel',
  VOD_NEXT_EPISODE: 'VODNextEpisode',
  EPG: 'EPG',
  LIVE_MINI_EPG: 'LIVEMiniEPG',
  LIVE_MINI_EPG_RECENT: 'LIVEMiniEPGRecent',
};

export function getPlaySourcePage(pageId) {
  return PLAY_SOURCE_PAGE[pageId] || (pageId ? `${pageId}${PLAY_SOURCE_PAGE.SUB_LANDER}` : '');
}
